<template>
  <section class="md:mt-8 m-auto bg-black pt-6 px-2 md:px-10 pb-5 shadow-black shadow-xl max-w-[1400px]">
    <div id="message"
      class="h-[60vh] w-full text-white font-electro text-[24px] flex flex-col text-center pt-16 md:pt-4">
      <div class="flex flex-col gap-4">
        <p class="mt-4 m-auto text-[16px] rn-positive rn-br" v-if="result == 0">Account activated successfully. Restart RallyNavigator to take effect.</p>
        <p class="mt-4 m-auto text-[16px] rn-negative rn-br" v-if="result == 1">Something bad happened.</p>
        <p class="mt-4 m-auto text-[16px] rn-negative rn-br" v-if="result == 3">This link is either Invalid or has
          Expired.</p>
      </div>
    </div>
  </section>
  <section class="mt-8">
    <PartnersSmall partners-title="true" />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
  <LoadingBar v-if="loading == true" message="Activating your Account..." />
</template>

<script>
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import LoadingBar from './LoadingBar.vue';
import { trackSignUp } from '../analytics';

export default {
  name: 'ActivateAccount',
  components: {
    PartnersSmall,
    RallyLogoDownload,
    LoadingBar,
  },
  data() {
    return {
      result: -1,
      token: this.getToken(),
      email: this.getEmail(),
      loading: false,
    };
  },
  mounted() {
    if (!this.token) {
      this.result = 3;
    } else {
      this.isLoading = true;
      this.activateAccount();
    }

  },
  methods: {
    async activateAccount() {
      this.loading = true;
      try {
        const response = await fetch(
          "https://api.rallynavigator.com/api/v2/auth/activate_account",
          {
            method: "POST",
            body: JSON.stringify({
              user: {
                email: this.email,
                emailVerificationToken: this.token,
              },
            }),
            headers: {
              "Content-Type": "application/json",
              "x-api-key": "Rw987ENLxJZyzB17Y3IH2Teu94IDLXl5AfWRsU50",
            },
          }
        );
        this.loading = false;
        //console.log(response)
        if (!response.ok) {
          //unvalid or expired token
          this.result = 3;
          return
        }
        const result = await response.json();
        if (result.success === true) {
          this.result = 0;
          trackSignUp();
        } else {
          switch (result.error_code) {
            case "0002":
              this.result = 1;
              //passwords don't match - validation on the backend - should never fall into this case
              break;
            default:
              this.result = 1;
              break;
          }
        }
      } catch (error) {
        console.log('Error activating account:', error);
        this.loading = false;
        this.result = 1; // Set to an error state
      }
    },
    getToken() {
      return this.$route.query.q;
    },
    getEmail() {
      // The activation link carries the email unencoded (&e=name+tag@gmail.com) and
      // query parsing turns "+" into a space. Emails never contain spaces, so put the
      // "+" back — otherwise anyone with a "+" alias can't activate.
      const e = this.$route.query.e;
      return typeof e === 'string' ? e.replace(/ /g, '+') : e;
    },
  },

};
</script>

<style scoped>
.rn-positive {
  background-color: green;
  border: 3px solid lightgreen;
  padding: 10px;
  min-width: 300px;
}

.rn-negative {
  background-color: darkred;
  border: 3px solid red;
  padding: 10px;
  min-width: 300px;
}

.rn-br {
  border-radius: 4px;
}

.week {
  font-weight: bold;
  color: red;
}

.good {
  font-weight: bold;
  color: lightgreen;
}
</style>
